module.exports = __webpack_public_path__ + "static/media/br.182f9e33.svg";